import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout/layout';
// import Seo from '../components/seo';
import { StaticImage } from 'gatsby-plugin-image';
import { Helmet } from "react-helmet"
import ApphubInteractiveTourModule from '../components/genericFlexible/apphubInteractiveTourModule';
import '../sass/components/flexibleModules/_components.apphubGridSection.scss';
import '../sass/components/_components.apphubIndividual.scss';

export const query = graphql`
query ApphubPostIndividualQuery($slug: String!) {
  allWordpressApphub(filter: {slug: {eq: $slug}}) {
    edges {
      node {
        seo {
          opengraphTitle
          opengraphDescription
          metaKeywords
          metaDesc
          opengraphAuthor
          title
          focuskw
          opengraphImage {
            altText
            sourceUrl
          }
          readingTime
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            author {
              node {
                name
              }
            }
          }
        }
        title
        slug
        apphubfunctions {
          nodes {
            databaseId
            name
          }
        }
        apphubindustries {
          nodes {
            databaseId
            name
          }
        }
        apphubauthors{
          nodes{
            databaseId
            name
          }
        }
        apphubPostFields {
          apphubHeader
          apphubFlexibleFields {
            __typename
            ... on WordpressApphub_Apphubpostfields_ApphubFlexibleFields_ApphubInteractiveTourModule {
              maxWidth
              backgroundColor
              apphubInteractiveTourHeader
              apphubInteractiveTourTeaser
              apphubInteractiveTourIframeField
              apphubInteractiveTourIframeOverlayText
              apphubInteractiveTourIframeOverlayLink {
                target
                title
                url
              }
              apphubInteractiveTourIframeOverlayImage {
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
              }
              tabbedLayoutCheck
              additionalResourcesTabTitle
              additionalResourcesTabContent
              additionalResourcesTabImageCarousel {
                altText
                gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                caption
              }
              additionalResourcesRightSectionMainHeader
              additionalResourcesRightSectionMainLogo {
                altText
                sourceUrl
              }
              additionalResourcesRightSectionRepeater {
                title
                teaser
              }
              additionalResourcesRelatedResourcesTitle
              additionalResourcesRelatedResources {
                ... on WordpressApphub {
                  id
                  slug
                  apphubPostFields {
                    apphubHeader
                    apphubTeaser
                    apphubLinkInternalOrExternal
                    apphubExternalLink
                    apphubIllustration {
                      altText
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  allWordpressPage(filter: {slug: {eq: "solution-hub"}}) {
    edges {
      node {
        title
        slug
        seo {
          opengraphTitle
          opengraphDescription
          metaKeywords
          metaDesc
          opengraphAuthor
          title
          focuskw
          opengraphImage {
            altText
            sourceUrl
          }
          readingTime
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            author {
              node {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `

const ApphubIndividualModel = ({ data }) => {
  const postObject = data.allWordpressApphub.edges;
  const language = "EN";
  var regex = /(<([^>]+)>)/ig;
  return (
    <div className="cp-appHubWrapModel">
      <Layout graphData={data.allWordpressApphub.edges[0].node} signup="signup" footerBannerCheck="yes" apphub="yes">
        {data.allWordpressApphub.edges.map((indItem, index) => (
          <React.Fragment key={index}>
            {
              indItem.node.apphubPostFields.apphubFlexibleFields.map((modularItem, index) => (
                <React.Fragment key={index}>
                  {modularItem.__typename === 'WordpressApphub_Apphubpostfields_ApphubFlexibleFields_ApphubInteractiveTourModule' &&
                    <Helmet
                      htmlAttributes={{
                        language,
                      }}
                      title={modularItem.apphubInteractiveTourHeader ? modularItem.apphubInteractiveTourHeader : "Interactive tour model title"}
                      titleTemplate={`%s | Solution Hub by planful`}
                      meta={[
                        {
                          name: `description`,
                          content:
                            modularItem.apphubInteractiveTourTeaser ? modularItem.apphubInteractiveTourTeaser.replace(regex, '') : "Interactive tour model teaser",
                        },
                        {
                          name: `keywords`,
                          content: "Keywords by planful",
                        },
                        {
                          property: `og:title`,
                          content: modularItem.apphubInteractiveTourHeader ? modularItem.apphubInteractiveTourHeader : "Interactive tour model title",
                        },
                        {
                          property: `og:description`,
                          content:
                          modularItem.apphubInteractiveTourTeaser ? modularItem.apphubInteractiveTourTeaser.replace(regex, '') : "Interactive tour model teaser",
                        },
                        {
                          property: `og:type`,
                          content: `website`,
                        },
                        {
                          name: `twitter:card`,
                          content: `summary`,
                        },
                        {
                          name: `twitter:creator`,
                          content: "Planful",
                        },
                        {
                          name: `twitter:title`,
                          content: modularItem.apphubInteractiveTourHeader ? modularItem.apphubInteractiveTourHeader : "Interactive tour model title",
                        },
                        {
                          name: `twitter:description`,
                          content:
                          modularItem.apphubInteractiveTourTeaser ? modularItem.apphubInteractiveTourTeaser.replace(regex, '') : "Interactive tour model teaser",
                        },
                      ]}
                    />
                  }
                </React.Fragment>
              ))
            }
          </React.Fragment>
        ))}
        {postObject.map((indItem, index) => (
          <React.Fragment key={index}>
            {indItem.node.apphubPostFields.apphubFlexibleFields &&
              <div className="cp-flexible cp-wrapper">
                <div className="cp-flexible__inner">
                  {indItem.node.apphubPostFields.apphubFlexibleFields.map((modularItem, index) => (
                    <React.Fragment key={index}>
                      {modularItem.__typename === 'WordpressApphub_Apphubpostfields_ApphubFlexibleFields_ApphubInteractiveTourModule' &&
                        <ApphubInteractiveTourModule postObject={postObject} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                      }
                    </React.Fragment>
                  ))}
                </div>
              </div>
            }
          </React.Fragment>
        ))}
      </Layout>
    </div>
  )
}

export default ApphubIndividualModel;